export default {
  data: () => ({
    x: 0,
    y: 0,
    selectItem: undefined,
    caption: ''
  }),
  computed: {
    fullPathText() {
      return this.$store.getters.getFullPath.fullPathText
    },
    fullPathUrl() {
      if (this.$store.getters.getFullPath && this.selectItem) {
        let parts = this.$store.getters.getFullPath.fullPathUrl.split('?')
        return `${parts[0]}?${this.selectItem.shareParams}${parts[1]}`
      }
      return this.$store.getters.getFullPath.fullPathUrl
    }
  },
  methods: {
    openContextMenu(item, event) {
      this.x = event.clientX
      this.y = event.clientY
      this.showContextMenu = true
      this.selectItem = item
      event.preventDefault()
    },
    openInNewTab() {
      if (this.selectItem.httpLink) {
        window.open(this.selectItem.httpLink)
        return
      }
      this.openLink(this.selectItem, '_blank')
    },
    openLink(item, target) {
      if (!this.$store.getters.getBaseUrl) {
        return
      }
      localStorage.setItem('startFromLauncher', true)
      let data = JSON.parse(localStorage.getItem('appMainMenuCacheMenu'))
      let projectCode = data.data.iTEnterpriseMenuQuery.menu.currentProject
      if (projectCode) {
        let parts = projectCode.split('_')
        if (parts.length > 1 && parts[parts.length - 1].length == 2) {
          parts[parts.length - 1] = localStorage.getItem('language')
        }
        projectCode = parts.join('_')
      }
      
      let link = `${this.$store.getters.getBaseUrl}/?${item.shareParams}&startFromLauncher=true${this.parseQueryString(projectCode)}`
      if (this.$store.getters.appModel.ProjectSecurity.OidcEnabled) {
        window.open(link, target)
      } else {
        this.$store.dispatch('getRestartTicket').then(() => {
          let ticket = ''
          if (this.$store.getters.getRestartTicket) {
            ticket = `&ticket=${this.$store.getters.getRestartTicket}`
          }
          window.open(`${link}${ticket}`, target)
        })
      }
    },
    parseQueryString(projectCode) {
      let query = location.search
      if (query.indexOf('?') >= 0) {
        query = query.substring(query.indexOf('?') + 1)
      }
      let parts = query.split('&')
      if (parts.length == 1 && !parts[0]) {
        parts = []
      }
      let params = {}

      if (projectCode) {
        params.proj = projectCode
      }

      for (let i = 0, ii = parts.length; i < ii; ++i) {
        let param = parts[i].split('=')
        let key = param[0].toLowerCase()
        let value = param.length > 1 ? param[1] : null
        params[decodeURIComponent(key)] = decodeURIComponent(value)
      }
      let noNeededParams = ['changeuser', 'restart', 'ticket', 'clientdevice', 'islandscape', 'startfromlauncher']
      let startParams = []
      for (let param in params) {
        if (noNeededParams.includes(param)) {
          continue
        }
        if (param == 'par3') {
          // если значение пустое
          if (params[param] == ';/') {
            continue
          }
          let oldValue = params[param].substring(1)	
          oldValue = oldValue.split('/')
          let newValue = []
          for (let value in oldValue) {
            if (oldValue[value].startsWith('ITCALL') || oldValue[value].startsWith('KEYMNU')) {
              continue
            }
            newValue.push(oldValue[value])
          }
          params[param] = (`;/${newValue.join('/')}`)
        }
        startParams.push(`${param}=${params[param]}`)
      }
      return startParams.length > 0 ? `&${startParams.join('&')}` : ''
    },
    toShare() {
      this.$store.dispatch('getFullPath', this.selectItem.codeMenu, this.selectItem.shareParams)
      this.showShareDialog = true
    },
    removeFromFavorite() {
      this.$store.dispatch('removeFromFavorite', this.selectItem.codeMenu)
    },
    renameFunctionMenu(caption) {
      this.$store.dispatch('renameFunctionMenu', { codeMenu: this.selectItem.codeMenu, npp: this.selectItem.npp, caption: caption } )
    },
    openRenameDialog() {
      this.showRenameDialog = true
      this.caption = this.selectItem.name
    },
    closeDialog() {
      this.showRenameDialog = this.showShareDialog = false
      this.selectItem = undefined
    },
    menuSettingsAccess(allUsers) {
      if (window.parent && window.parent.postMessage && window.parent != window) {
        window.parent.postMessage({ type: 'CallMainMenuSettingsAccess', codeMenu: this.selectItem.codeMenu, allUsers: allUsers }, window.location.origin)
        return
      }
    }
  }
}